// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2uk8n","avatar":"style_avatar__3nLJJ"};